<div class="ziro-admin-page-content">
  <div class="col-md-10 offset-md-1 d-flex flex-column h-100">
    <ziro-breadcrumbs>
      <ziro-breadcrumb-card-item [aboutCardId]="64"></ziro-breadcrumb-card-item>
    </ziro-breadcrumbs>

    <ziro-loading-block [hidden]="!isLoading"></ziro-loading-block>

    @if (!isLoading) {
      <ziro-datatable
        [rowDataSource]="data"
        [columns]="columns"
        [dataAutomation]="'policy-misconfiguration-report-datatable'"
        [uniqueRowIdentifier]="'userPrincipalName'"
        [stickyColumnCount]="1"
        [showSelectColumn]="true"
        [mainFilterPlaceholder]="'tkey;migrations.number_report.table.filter.placeholder' | translate"
        [resetPageOnDataChange]="false"
        [noResultsAlert]="'tkey;reports.microsoft.policy_misconfig.table.no_results_message'"
        [noResultsAlertClass]="!data.length && 'table-success'"
        (rowFieldChanged)="onRowFieldChange($event)"
        (rowSelected)="onRowSelected()"
        (searchResultsChanged)="onSearchResultsChanged()"
        [class]="'ziro-card'"
      >
        <ziro-datatable-multi-select-filter
          [label]="'tkey;reports.microsoft.policy_misconfig.table.filter.misconfigured_policies.label'"
          [items]="misconfiguredPoliciesOptions"
          [matchFn]="misconfiguredPoliciesMatchFnBound"
          [dataAutomation]="'misconfigured-policies-filter'"
          [matchValue]="true"
          [tableId]="tableDataAutomation"
          [showRowCount]="true"
        ></ziro-datatable-multi-select-filter>
        <ziro-datatable-multi-select-filter
          #dialPlanGroupFilter
          [label]="'tkey;reports.microsoft.policy_misconfig.table.dial_plan_group.label'"
          [items]="dialPlanGroupOptions"
          [matchFn]="dialPlanGroupMatchFnBound"
          [dataAutomation]="'dial-plan-group-filter'"
          [tableId]="tableDataAutomation"
        ></ziro-datatable-multi-select-filter>
        <ziro-datatable-switch-filter
          #showIgnoredUsersFilter
          [label]="'tkey;reports.microsoft.policy_misconfig.table.filter.show_ignored_users.label'"
          [matchFn]="showIgnoredUsersMatchFn"
          [dataAutomation]="'hide-ignored-users-filter'"
          [tableId]="tableDataAutomation"
        ></ziro-datatable-switch-filter>
      </ziro-datatable>
    }
  </div>
</div>

<ziro-bottom-nav></ziro-bottom-nav>
